import React from 'react';
import { CardBody } from '@ekhodealer/ekho-common/components';
import PurchasePreviewContainer from '../purchasePreviewComponents/PurchasePreviewContainer';

const PurchasePreviewLoading = () => {
	return (
		<PurchasePreviewContainer>
			<CardBody
				className='p-0'
				style={{
					width: '100%',
					display: 'flex',
					flexDirection: 'column',
					gap: '2rem',
				}}>
				<h1 className='card-title ekho-placeholder-wave h1'>
					<span className='ekho-placeholder col-6' />
				</h1>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center', // Center horizontally
						justifyContent: 'center', // Center vertically
						height: '90%',
						width: '100%', // Ensure it takes the full width
						flex: 1,
						gap: '2rem',
					}}
					className='ekho-placeholder-wave'>
					<div
						className='p-0 ekho-placeholder-wave'
						style={{ width: '100%' }}
						id='not-showing'>
						<span
							className='ekho-placeholder col-12'
							style={{ height: '40vh', maxHeight: '560px', minHeight: '6rem' }}
						/>
					</div>
					<div
						className='p-0 col-12 ekho-placeholder-wave'
						style={{
							padding: '0',
							alignItems: 'center',
							justifyContent: 'center',
							display: 'flex',
							gap: '2rem',
						}}>
						<div
							className='p-0 ekho-placeholder-wave'
							style={{
								height: '60px',
								aspectRatio: 1,
							}}>
							<span className='ekho-placeholder col-12 h-100' />
						</div>
						<div
							className='p-0 ekho-placeholder-wave'
							style={{
								height: '60px',
								aspectRatio: 1,
							}}>
							<span className='ekho-placeholder col-12 h-100' />
						</div>
						<div
							className='p-0 ekho-placeholder-wave'
							style={{
								height: '60px',
								aspectRatio: 1,
							}}>
							<span className='ekho-placeholder col-12 h-100' />
						</div>
					</div>
				</div>
				<div className='col-md-12'>
					<table className='table table-borderless table-total-row'>
						<thead>
							<tr key='subtotal'>
								<td className='tableLeftStyle ekho-placeholder-wave'>
									<span
										className='ekho-placeholder h-100'
										style={{ width: '120px', display: 'inline-block' }}
									/>
								</td>
								<td className='tableRightStyle ekho-placeholder-wave'>
									<span
										className='ekho-placeholder h-100'
										style={{ width: '80px', display: 'inline-block' }}
									/>
								</td>
							</tr>
							<tr key='shipping'>
								<td className='tableLeftStyle ekho-placeholder-wave'>
									<span
										className='ekho-placeholder h-100'
										style={{ width: '120px', display: 'inline-block' }}
									/>
								</td>
								<td className='tableRightStyle ekho-placeholder-wave'>
									<span
										className='ekho-placeholder h-100'
										style={{ width: '80px', display: 'inline-block' }}
									/>
								</td>
							</tr>
							<tr key='total'>
								<td className='tableLeftStyle ekho-placeholder-wave'>
									<span
										className='ekho-placeholder h-100'
										style={{ width: '120px', display: 'inline-block' }}
									/>
								</td>
								<td className='tableRightStyle ekho-placeholder-wave'>
									<span
										className='ekho-placeholder h-100'
										style={{ width: '80px', display: 'inline-block' }}
									/>
								</td>
							</tr>
							<tr key='due today' className='table-section-title'>
								<td className='tableLeftStyle ekho-placeholder-wave'>
									<span
										className='ekho-placeholder h-100'
										style={{ width: '120px', display: 'inline-block' }}
									/>
								</td>
								<td className='tableRightStyle ekho-placeholder-wave'>
									<span
										className='ekho-placeholder h-100'
										style={{ width: '80px', display: 'inline-block' }}
									/>
								</td>
							</tr>
						</thead>
					</table>
				</div>
			</CardBody>
		</PurchasePreviewContainer>
	);
};

export default PurchasePreviewLoading;
